import React from 'react';
import MainLayout from 'components/layout/MainLayout';
import BlogArticle from 'components/blog/BlogArticle';
import { ASSET_PREFIX } from 'utils/constants';
import { NextSeo } from 'next-seo';
import RoundedButton from 'components/RoundedButton';
import Separator from 'components/Separator';
import { getCta } from 'utils/common';

const Article = () => {
  const IMAGE_DIRECTORY = `${ASSET_PREFIX}/images/blog/articles/lifestyle-prize-highlights`;

  return (
    <MainLayout>
      <NextSeo
        title="Our Top Lifestyle Prizes | Win Epic Prizes | DAYMADE"
        description="Find out what lifestyle prizes you can win in the DAYMADE draw! We delve into our favourites from Drunk Elephant to Peloton."
        openGraph={{
          title: 'Our Top Lifestyle Prizes | Win Epic Prizes | DAYMADE',
          description:
            'Find out what lifestyle prizes you can win in the DAYMADE draw! We delve into our favourites from Drunk Elephant to Peloton.',
          type: 'article',
          url: 'https://www.daymade.co.uk/blog/lifestyle-prize-highlights',
          images: [
            {
              url: `${IMAGE_DIRECTORY}/hero.jpg`,
              alt: '2 people smiling in a kitchen full of Le Creuset',
            },
          ],
        }}
        // additionalMetaTags={[{
        //   name: 'keywords',
        //   content: 'borough kitchen,all clad,kai shun,japanese knives,le creuset,smeg,kitchenaid,smart garden,delonghi,drunk elephant,the littles 4.0,framboos glycolic,sukari babyfacial,protini polypeptide,national trust,membership,gift card,peloton bike,authentic house,ethical lifestyle,sustainable',
        // }]}
      />

      <BlogArticle
        imageDirectory={IMAGE_DIRECTORY}
        heroAltText="2 people smiling in a kitchen full of Le Creuset"
        heroImageYPosition="33%"
      >
        <>
          <h1 style={{ fontSize: '1.6em', lineHeight: '1.4em' }}>
            Lifestyle Prize <strong>Highlights</strong>
          </h1>

          <p className="subheading">Five favourites from £25 to £10,000</p>

          <div
            className="separator"
            style={{ width: '80%', marginTop: 0 }}
          />

          <p
            style={{
              fontStyle: 'italic',
              textAlign: 'center',
              marginBottom: '2em',
            }}
          >
            by Abbi James
          </p>

          <p>
            <span className="bigFirstLetter">W</span>e thought it was about time
            to shed some light on five of our favourite lifestyle prizes, valued
            from £25 to £10,000. Fancy getting your hands on one (or three…) of
            ’em? They can all be won in our weekly draw for the price of a
            coffee!
          </p>

          <h3>Chef Bundle - £10,000 Prize</h3>

          <img
            src={`${IMAGE_DIRECTORY}/secondary1.jpg`}
            alt="2 women laughing as they assemble layers of sponge cake and berries"
            className="singleBlogImage"
          />

          <p>
            Hands up if you’ve watched just one episode of The Great British
            Bake-Off before thinking – that could be me! Whether you’re already
            a dab-hand in the kitchen, or looking to beef up your skills, we’re
            here to get you fully kitted out. Before long your kitchen will be
            decked out with the best appliances, accessories and kitchenware
            that even Paul Hollywood would shake your hand for.
          </p>

          <p>
            The first collection you’ll receive is Borough Kitchen’s Perfect
            Kitchen Complete Set, which consists of 73 items curated to create a
            dream kitchen setup. There’s copper pans from All-Clad, razor-sharp
            Kai Shun Japanese knives and French enamelled cocottes. Whether
            you’re moving to a new home, or looking to overhaul your existing
            kitchenware, this is the ultimate collection to last you a lifetime!
          </p>

          <p>
            We’ve also included £1,500 Le Creuset credit so you can spruce up
            some kitchen classics with these handmade cast iron icons. If you’re
            after a pop of colour, Le Creuset have some fab colour palettes for
            you to theme your new kitchen around. For the baking boffs, we’ve
            also thrown in £1,500 Smeg or KitchenAid credit for you to collate
            your ultimate bundle of baking tools and stand mixers.
          </p>

          <p>
            For those who love to grow their own vegetables, herbs and plants,
            we’ve also got you covered. The Smart Garden 27 by Click and Grow is
            the perfect way to bring the garden to your kitchen by providing
            plants with the perfect levels of light, water and nutrients to
            allow them to thrive indoors. No more sad light-deprived herbs here,
            no siree! You’ll get started with 27 plant pods including basil,
            green lettuce and mini tomato to bring some life back into your
            kitchen.
          </p>

          <p>
            You might be wondering what else could possibly be included in this
            ultimate kitchen bundle?! Well we’ve got to admit that no kitchen is
            truly complete without a coffee machine. Our final addition to your
            new space is the DeLonghi Lattissima Pro Nespresso coffee machine,
            with touchscreen display and a sleek design. Now you’ll be enjoying
            luxury coffee from the comfort of your own home in no time at all!
          </p>

          <h3>Drunk Elephant - £500 Prize</h3>

          <img
            src={`${IMAGE_DIRECTORY}/secondary2.jpg`}
            alt="Framboos Glycolic Night Serum from the Drunk Elephant T.L.C. range"
            className="singleBlogImage"
          />

          <p>
            The Drunk Elephant craze is here to stay, and now’s your chance to
            get the full experience first-hand. We’ve put together what we
            believe to be the ultimate Drunk Elephant bundle, including two
            bestselling kits and eight individual products sure to find their
            way into your favourites. We’re big fans of Drunk Elephant’s
            philosophy and approach to their ingredients lists. By not including
            the forbidden 6 ingredients that they believe to be at the root of
            most skin issues, they provide skincare that allows skin to reset
            and thrive. An emphasis on listening to what our skin needs, rather
            than just looping through the same routine year after year, has led
            to Drunk Elephant’s #barewithus movement. GET that glow!
          </p>

          <p>
            The first kit in our Drunk Elephant bundle is the bestselling The
            Littles 4.0 collection, which unites eight of the brand’s most-loved
            products in travel-size form. This includes the Beste™ No. 9 Jelly
            Cleanser, C-Firma™ Day Serum, B-Hydra™ Intensive Hydration Serum,
            T.L.C. Framboos™ Glycolic Night Serum, Virgin Marula Luxury Facial
            Oil, Protini™ Polypeptide Cream, Umbra Sheer™ Physical Daily Defense
            SPF 30 and the C-Tango™ Multivitamin Eye Cream. What a list. As an
            added bonus, you’ll also get your hands on 4 smoothie recipe cards
            and a bright coral waterproof travel bag – perfect for keeping your
            faves with you on-the-go!
          </p>

          <p>
            We have two standalone products from the T.L.C. range, the first of
            which being the T.L.C. Framboos Glycolic Night Serum. This serum
            helps to refine and resurface the skin, leaving it smoother and
            looking more radiant – perfect to help you get up and glow! There’s
            also the T.L.C. Sukari Babyfacial, which is the closest thing to a
            facial that you can get in the comfort of your own home. This potent
            yet perfectly formulated concoction is the ultimate resurfacing
            treatment for baby-soft skin.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary3.jpg`}
            alt="Sukari Babyfacial from the Drunk Elephant T.L.C. range"
            className="singleBlogImage"
          />

          <p>
            Next on our list is the Protini™ Polypeptide Cream. This moisturiser
            is jam-packed with all that your skin needs to keep it hydrated and
            balanced whilst encouraging the production of collagen. For more
            specialised hydration, we’ve also thrown in the C-Tango Multivitamin
            Eye Cream full of peptides, vitamin C and cucumber extract. If
            you’re looking to regain that youthful-looking skin (aren’t we all),
            this could be your holy grail! Thanks Drunk Elephant!
          </p>

          <p>
            If you’ve never used a facial oil before, this next one’s sure to
            blow your socks off. The Virgin Marula Luxury Facial Oil is a
            super-absorbable, nutrient-dense product that’s been
            clinically-proven to reverse signs of ageing….sign us up! Our ideal
            Drunk Elephant skincare bundle wouldn’t be complete without the
            Slaai Makeup-Melting Butter Cleanser, so that you can melt away all
            traces of makeup, dirt and debris before treating your skin. It’s a
            must-try for any Drunk Elephant devotee, and we think it’ll be a
            firm favourite of our winners too.
          </p>

          <p>
            Finally, the duo to beat all duos…the Juju and Pekee bars. These
            3-in-1 bars are iconic staples in every Drunk Elephant fan’s kit.
            They’re mild enough to exfoliate and cleanse whilst balancing and
            moisturising the skin for that soft, smooth complexion. With this
            ultimate Drunk Elephant skincare bundle, you’ll be saying hello to a
            brand new you.
          </p>

          <h3>National Trust Membership - £100 Prize</h3>

          <img
            src={`${IMAGE_DIRECTORY}/secondary4.jpg`}
            alt="The gardens of a National Trust property, with a grand house in the background"
            className="singleBlogImage"
          />

          <p>
            This next prize is one of our newer lifestyle additions, providing
            you with countless days-out filled with feel-good adventure. For 125
            years, the National Trust has worked to protect and care for nature,
            beauty and history – and now you can enjoy their work too! This
            prize is a 12-month National Trust Membership, coupled with a £25
            gift card to spend in cafes and gift shops during your visits.
          </p>

          <p>
            The National Trust cares for more than 500 castles, gardens, houses
            and parks scattered across the UK from Lindisfarne in Northumberland
            to Lizard Point in Cornwall. Art and history lovers will find
            themselves immersed in one of the world’s largest art and heritage
            collections, consisting of over one million items. See first-hand
            the first national Atlas of the Counties of England and Wales in
            Anglesey Abbey, or gaze upon Woolfs impressive art collection in
            Monk’s House. Those who prefer to be in the great outdoors can
            stroll through Beatrix Potter’s garden at Hill Top in the Lake
            District, or discover Cornwall’s best coastal walks.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary5.jpg`}
            alt="Sheep standing in long grass in the countryside"
            className="singleBlogImage"
          />

          <p>
            Whether you’re an adventurer or observer, the National Trust has
            something for everyone to enjoy. We couldn’t help but include a
            12-month membership as one of our prizes, and after this last year,
            you can see why they’re one of our current faves!
          </p>

          <h3>Peloton Bike & Membership - £2,500 Prize</h3>

          <p>
            Home workouts are good – great, even – but after a while it can get
            difficult to motivate yourself each and every week. Those New Year
            Resolutions are notoriously tricky to stick to, after all. That’s
            why we introduced the world of Peloton to our prize list!
          </p>

          <p>
            The Peloton Bike Works package includes everything you need to
            immerse yourself in the most convenient indoor cycling experience.
            Your 12-month Peloton All-Access Membership gives you 24-hour access
            to studio cycling classes, a personalised workout experience and
            real-time performance metrics to keep you motivated. To keep you on
            track, you’ll also receive cycling shoes, bike weights, a heart rate
            monitor and Urbanears Sumpan earbuds. Whilst we know the bike is the
            star of the show, all the added gadgets and gizmos are there to make
            your Peloton journey the very best it can be. You’ve got this!
          </p>

          <h3>Eco Gift Box - £25 Prize</h3>

          <img
            src={`${IMAGE_DIRECTORY}/secondary6.jpg`}
            alt="An eco gift box from Authentic House"
            className="singleBlogImage"
          />

          <p>
            We couldn’t possibly highlight some of our fave lifestyle prizes
            without mentioning the eco gift box from Authentic House. This is
            one of our most popular £25 prizes, and we’re sure you’ll see why.
            Each box contains 6-7 eco-friendly lifestyle products to give you
            the best start to incorporating more sustainable living into
            everyday life. Each product is specially selected, ethically sourced
            and cruelty free.
          </p>

          <p>
            Wondering what might be in your box? Each box is filled to the brim
            with sustainable products that enable you to make everyday choices
            that are better for the planet. Your goodies could range from hand
            balms to candles, vegan snacks to cleaning essentials! One of the
            reasons we’re such big fans of this lifestyle prize is because it’s
            easy to try out new sustainable products to incorporate into your
            everyday routine. Thanks Authentic House!
          </p>

          <Separator style={{ margin: '2em' }} />

          <p>
            Fancy a chance to win one of our favourite lifestyle prizes? Try
            your luck and enter the draw today!
          </p>

          <RoundedButton
            href={getCta()?.url}
            style={{ minWidth: '180px', marginTop: '1.5em' }}
          >
            Enter Now
          </RoundedButton>
        </>
      </BlogArticle>
    </MainLayout>
  );
};

export default Article;
